import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/Button';
import { callCenterApi, SimpleCustomer, CallNoteDto } from '@/api/callcenter';
import toast from 'react-hot-toast';

const AgentCustomers: React.FC = () => {
  const [customers, setCustomers] = useState<SimpleCustomer[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<number | null>(null);
  const [notes, setNotes] = useState<CallNoteDto[]>([]);
  const [noteText, setNoteText] = useState('');

  const refresh = async () => {
    try {
      const list = await callCenterApi.assignments.myCustomers();
      setCustomers(list);
    } catch (e: any) {
      toast.error(e.message || 'Müşteriler yüklenemedi');
    }
  };

  const loadNotes = async (cid: number) => {
    try {
      const data = await callCenterApi.notes.list(cid);
      setNotes(data);
      setSelectedCustomer(cid);
    } catch (e: any) {
      toast.error(e.message || 'Notlar yüklenemedi');
    }
  };

  const addNote = async () => {
    if (!selectedCustomer || !noteText.trim()) { toast.error('Not metni zorunludur'); return; }
    try {
      await callCenterApi.notes.create(selectedCustomer, noteText.trim());
      setNoteText('');
      await loadNotes(selectedCustomer);
      toast.success('Not eklendi');
    } catch (e: any) {
      toast.error(e.message || 'Not eklenemedi');
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <div className="p-6 space-y-6">
      <div className="pb-5 border-b border-slate-200">
        <p className="text-xs font-semibold uppercase tracking-wide text-primary-600 mb-1">Callcenter</p>
        <h1 className="text-2xl font-serif font-medium text-slate-900">Müşteriler</h1>
        <p className="text-slate-600 mt-1">Size atanan müşteriler</p>
      </div>

      <div className="bg-white border border-slate-200 border-t-2 border-t-primary-600 p-6">
        <div className="grid md:grid-cols-2 gap-3">
          {customers.map(c => (
            <div key={c.id} className="border border-slate-200 p-4 flex items-center justify-between">
              <div>
                <div className="font-medium text-slate-900">{c.full_name || `Müşteri #${c.id}`}</div>
                <div className="text-sm text-slate-500">ID: {c.id}</div>
              </div>
              <Button variant="outline" onClick={() => loadNotes(c.id)}>Notlar</Button>
            </div>
          ))}
          {customers.length === 0 && <div className="text-sm text-slate-500">Henüz atanmış müşteri yok</div>}
        </div>
      </div>

      {selectedCustomer && (
        <div className="bg-white border border-slate-200 border-t-2 border-t-gold-500 p-6">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-4">Müşteri Notları (ID: {selectedCustomer})</h2>
          <div className="flex gap-2 mb-3">
            <input
              className="border border-slate-300 px-3 py-2 flex-1 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none"
              placeholder="Not yazın"
              value={noteText}
              onChange={(e)=>setNoteText(e.target.value)}
            />
            <Button onClick={addNote}>Ekle</Button>
          </div>
          <div className="space-y-2">
            {notes.map(n => (
              <div key={n.id} className="border border-slate-200 p-3">
                <div className="text-sm text-slate-500 mb-1">{new Date(n.created_at).toLocaleString('tr-TR')}</div>
                <div className="text-slate-900">{n.note_text}</div>
              </div>
            ))}
            {notes.length === 0 && <div className="text-sm text-slate-500">Henüz not yok</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentCustomers;
